export const getDetectedLanguageLabel = (detectedLanguage: string) =>
  new Intl.DisplayNames(["en"], { type: "language" }).of(detectedLanguage) ?? detectedLanguage;
